import { render, staticRenderFns } from "./OptionsList.vue?vue&type=template&id=ff25cea4&lang=pug"
import script from "./OptionsList.vue?vue&type=script&lang=js"
export * from "./OptionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports